const SA = {
  ibanLength: 24,
};
export { SA };
